__turbopack_context__.v({
  "allEditionsLink": "work-copy-selector-module-scss-module__103aEa__allEditionsLink",
  "belowSmallBestAvailable": "work-copy-selector-module-scss-module__103aEa__belowSmallBestAvailable",
  "belowSmallChevron": "work-copy-selector-module-scss-module__103aEa__belowSmallChevron",
  "belowSmallLabelRow": "work-copy-selector-module-scss-module__103aEa__belowSmallLabelRow",
  "belowSmallLoyaltyBonusBadge": "work-copy-selector-module-scss-module__103aEa__belowSmallLoyaltyBonusBadge",
  "belowSmallSectionLabel": "work-copy-selector-module-scss-module__103aEa__belowSmallSectionLabel",
  "belowSmallSelection": "work-copy-selector-module-scss-module__103aEa__belowSmallSelection",
  "belowSmallSelectionValue": "work-copy-selector-module-scss-module__103aEa__belowSmallSelectionValue",
  "belowSmallSelectors": "work-copy-selector-module-scss-module__103aEa__belowSmallSelectors",
  "conditionDescription": "work-copy-selector-module-scss-module__103aEa__conditionDescription",
  "conditionOption": "work-copy-selector-module-scss-module__103aEa__conditionOption",
  "conditionOptionWrapper": "work-copy-selector-module-scss-module__103aEa__conditionOptionWrapper",
  "conditionPrice": "work-copy-selector-module-scss-module__103aEa__conditionPrice",
  "dealIcon": "work-copy-selector-module-scss-module__103aEa__dealIcon",
  "hasLoyaltyBonus": "work-copy-selector-module-scss-module__103aEa__hasLoyaltyBonus",
  "labelRow": "work-copy-selector-module-scss-module__103aEa__labelRow",
  "loyaltyBonusBadge": "work-copy-selector-module-scss-module__103aEa__loyaltyBonusBadge",
  "option": "work-copy-selector-module-scss-module__103aEa__option",
  "optionGrid": "work-copy-selector-module-scss-module__103aEa__optionGrid",
  "optionTitle": "work-copy-selector-module-scss-module__103aEa__optionTitle",
  "root": "work-copy-selector-module-scss-module__103aEa__root",
  "selected": "work-copy-selector-module-scss-module__103aEa__selected",
  "selectedConditionPrice": "work-copy-selector-module-scss-module__103aEa__selectedConditionPrice",
  "selectorLabel": "work-copy-selector-module-scss-module__103aEa__selectorLabel",
  "smallAndUpSelectors": "work-copy-selector-module-scss-module__103aEa__smallAndUpSelectors",
  "thriftDealPrice": "work-copy-selector-module-scss-module__103aEa__thriftDealPrice",
  "u-animation-bounce": "work-copy-selector-module-scss-module__103aEa__u-animation-bounce",
});
